// extracted by mini-css-extract-plugin
export var auto = "_2o-1";
export var spinner = "_2o-0";